import { Newsletters } from './pages';

export default {
  key: 'newsletters',
  hasSidebar: true,
  isPrivate: true,
  exact: true,
  path: '/schools/:sid/school-newsletters',
  component: Newsletters,
};
